import { endpoints } from '@/services/endpoints';
import { axiosGetRequest } from '@/services/Request';
import { useQuery } from '@tanstack/react-query';
import { AppCard } from '@/components/ui/AppCard';
import { AppPieChart } from '@/components/charts/pieChart/AppPieChart';

export default function TicketChartsByType() {
  const { data: AllTicketTypes, isLoading } = useQuery({
    queryKey: ['ticketTypes'],
    queryFn: () => axiosGetRequest(endpoints.getTicketByType),
  });
  const config = {
    count: {
      label: 'Total Count',
      color: '#0D9373',
    },
    user: {
      label: 'User',
      color: '#F59E0B',
    },
    chat: {
      label: 'Chat',
      color: '#3B82F6',
    },
    bug: {
      label: 'Bug',
      color: '#EF4444',
    },
    book: {
      label: 'Book',
      color: '#10B981',
    },
  };

  const totalCounts = AllTicketTypes?.totalCount || 'N/A';
  return (
    <AppCard>
      <h5 className="mb-4 text-base font-semibold text-coal-900">Tickets by Type</h5>
      <AppPieChart
        chartData={AllTicketTypes?.data}
        dataKey="count"
        nameKey="type"
        config={config}
        innerData={{ value: totalCounts, title: 'Total' }}
        isLoading={isLoading}
      />
    </AppCard>
  );
}
